import styled from 'styled-components'
import { SvgIcon } from '@/components'
import { useLocation, useNavigate } from 'react-router-dom'
import { HeaderRight } from './header-right'
import { useEffect, useState, useCallback, memo } from 'react'
import { useDispatch } from 'react-redux'
import { addToken } from '@/redux/userSlice'
import { Button } from 'antd'
import { getQueryParameter } from '@/utils'
import { setMenuInfo } from '@/redux/menuSlice'
import React from 'react'
import { t } from '@/i18n'
const token = getQueryParameter(window.location.href, 'token') || ''
const id = getQueryParameter(window.location.href, 'id') || ''
interface MenuItemProps {
  text: React.ReactElement
  test: RegExp
  pathName: string
  subMenuItems?: JSX.Element
  to?: string
  show?: boolean
  handelTopMenu?: (text: string) => void
  menuName?: string // 英文别名，用于标识菜单，不受翻译影响
}

interface SubMenuItemProps {
  text: string
  test?: RegExp
  pathName?: string
  subMenuItems?: JSX.Element
  to?: string
  show?: boolean
  level?: number
  icon?: JSX.Element
  menuName?: string // 英文别名，用于标识菜单，不受翻译影响
}

export const MenuItem = (props: MenuItemProps) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { text, test, pathName, subMenuItems = null, to, handelTopMenu, menuName } = props

  const isActive = test.test(pathName)
  const clickMenuHandler = e => {
    if (menuName === 'overview') {
      navigate('/overview/dashboard')
      return
    }

    if (menuName === 'operation-management') {
      return
    }

    if (handelTopMenu) {
      handelTopMenu(e.target.innerText)
    }
    // 分发菜单点击事件
    dispatch(
      setMenuInfo({
        text: e.target.innerText,
        to,
        subMenuItems,
        menuName,
      }),
    )

    if (menuName === 'validation' && subMenuItems) {
      const children = subMenuItems?.props?.children
      let awarenessGroup
      if (Array.isArray(children)) {
        awarenessGroup = children.find(
          child => child?.props?.to === '/validation/awareness' && child?.props?.show,
        )
      } else if (children?.props) {
        awarenessGroup =
          children.props.to === '/validation/awareness' && children.props.show ? children : null
      }

      if (awarenessGroup && awarenessGroup.props.subMenuItems) {
        const third = awarenessGroup.props.subMenuItems?.props?.children
        if (Array.isArray(third)) {
          const phishingItem = third.find(
            child => child?.props?.to === '/validation/awareness/phishing' && child?.props?.show,
          )
          if (phishingItem) {
            navigate(phishingItem.props.to)
            return
          }
        } else if (third?.props) {
          if (
            third.props.to === '/validation/awareness/phishing' &&
            third.props.show &&
            third.props.to
          ) {
            navigate(third.props.to)
            return
          }
        }
      }
    }

    if (menuName === 'report') {
      navigate('/report/task/task-report')
      return
    }

    // 如果有子菜单,则查找第一个可显示的子菜单进行跳转
    if (subMenuItems) {
      const subMenuItemsChildren = subMenuItems?.props?.children
      if (Array.isArray(subMenuItemsChildren)) {
        const firstSubMenu = subMenuItemsChildren.find(
          child => child?.props && child.props.show === true,
        )
        if (firstSubMenu) {
          if (firstSubMenu.props.subMenuItems) {
            const thirdMenuItems = firstSubMenu.props.subMenuItems.props.children
            if (Array.isArray(thirdMenuItems)) {
              const firstThirdMenu = thirdMenuItems.find(
                child => child?.props && child.props.show === true,
              )
              if (firstThirdMenu) {
                navigate(firstThirdMenu.props.to)
                return
              }
            } else if (thirdMenuItems?.props) {
              if (thirdMenuItems.props.show === true && thirdMenuItems.props.to) {
                navigate(thirdMenuItems.props.to)
                return
              }
            }
          }
          if (firstSubMenu.props.to) {
            navigate(firstSubMenu.props.to)
            return
          }
        }
      } else if (subMenuItemsChildren?.props?.to && subMenuItemsChildren?.props?.show === true) {
        navigate(subMenuItemsChildren.props.to)
        return
      }
    }
    if (to) {
      navigate(to)
    }
  }

  // 进入页面时就分发菜单信息
  useEffect(() => {
    if (test.test(pathName)) {
      dispatch(
        setMenuInfo({
          text: text,
          to,
          subMenuItems,
          menuName,
        }),
      )
    }
  }, [pathName])

  // 检查是否是态势概览菜单
  const isOverviewMenu = text.props.children[1]?.props?.children === '运维管理'

  return (
    <MenuItemContainer isActive={isActive} onClick={clickMenuHandler}>
      {text}
      {/* 只展示态势概览的下拉菜单 */}
      {subMenuItems !== null && isOverviewMenu && (
        <div className={'submenu-container'}>{subMenuItems}</div>
      )}
    </MenuItemContainer>
  )
}

const SubMenuItem = memo(
  React.forwardRef<HTMLDivElement, SubMenuItemProps>((props, ref) => {
    const navigate = useNavigate()
    const [showSub, setShowSub] = useState(false)
    const { text, test, pathName, subMenuItems = null, to, show, level = 1 } = props
    let isActive = false
    const subMenuItemsChildren = subMenuItems?.props?.children //Array、Object、null
    if (test && pathName) {
      isActive = test.test(pathName)
    }

    const clickHandler = useCallback(() => {
      if (!subMenuItems && to) {
        navigate(to)
      }

      if (level === 1) {
        if (Array.isArray(subMenuItemsChildren) && subMenuItemsChildren.length > 0) {
          const firstSubMenu = subMenuItems?.props?.children.find(child => child?.props?.show)

          if (firstSubMenu) {
            navigate(firstSubMenu.props.to)
          }
        } else if (subMenuItemsChildren && subMenuItemsChildren.props) {
          const firstSubMenu = subMenuItemsChildren
          if (firstSubMenu) {
            navigate(firstSubMenu?.props?.to)
          }
        }
      } else if (level === 2 && to) {
        navigate(to)
      }
    }, [subMenuItems, to, level, subMenuItemsChildren, navigate])

    const handleMouseEnter = useCallback(() => setShowSub(true), [])
    const handleMouseLeave = useCallback(() => setShowSub(false), [])
    const handleSubMenuClick = useCallback((event: React.MouseEvent) => event.stopPropagation(), [])

    return (
      <SubMenuItemContainer
        ref={ref}
        onClick={clickHandler}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        isActive={isActive}
        show={show}
      >
        <div className="menu-name-box">
          {text}
          {subMenuItemsChildren ? <SvgIcon width={6} height={12} name="arrow_right_grey" /> : null}
        </div>
        {subMenuItems !== null && (
          <div
            className={'submenu-container-3'}
            style={{ display: showSub ? 'flex' : 'none' }}
            onClick={handleSubMenuClick}
          >
            {subMenuItems}
          </div>
        )}
      </SubMenuItemContainer>
    )
  }),
)

SubMenuItem.displayName = 'SubMenuItem'

export const Header = ({ userInfo, superSU, Logo, menuList, type, handelTopMenu }) => {
  const dispatch = useDispatch()
  // 为了兼容第三方带token直接访问当前项目的情况
  if (token && id) {
    localStorage.setItem('token', JSON.stringify({ id, token }))
    dispatch(addToken(JSON.stringify({ id: id, token: token })))
  }
  const { pathname } = useLocation()
  const navigator = useNavigate()

  return (
    <>
      {/* 控制放到最顶端解决觅影登陆时中间会跳到bas header的问题 EASM-2632 */}
      {superSU && (
        <HeaderContainer fullScreen={false} id="header">
          <>
            <TitleContainer>
              {Logo !== '' && <img alt="..." className="logo" width={125} src={Logo} />}
            </TitleContainer>
            {localStorage.getItem('account_type') === '3' ? (
              <>
                <a
                  href={
                    process.env.NODE_ENV === 'dev'
                      ? `${location.protocol}//${location.hostname}:10/easm/overview
                      `
                      : '/easm/overview'
                  }
                >
                  <Button className="switchicon">
                    <SvgIcon width={25} height={18} name="切换" />
                  </Button>
                </a>
                <div className="hasMenuEmptyBox" />
              </>
            ) : (
              <div className="noMenuEmptyBox" />
            )}

            <HeaderContent>
              <div className="menu-content">
                <MenuItem
                  pathName={pathname}
                  text={
                    <div className="navigation">
                      <span />
                      <span className="title">{t('态势概览')}</span>
                    </div>
                  }
                  test={/^\/overview/}
                  handelTopMenu={handelTopMenu}
                  menuName="overview"
                  subMenuItems={
                    <>
                      <SubMenuItem
                        to={'/overview/dashboard'}
                        text={t('仪表盘')}
                        test={/^\/overview\/dashboard/}
                        pathName={pathname}
                        key={'dashboard'}
                        level={1}
                        show
                        icon={<SvgIcon width={16} height={16} name={'仪表盘'} />}
                      />

                      <SubMenuItem
                        text={'ATT&CK'}
                        test={/^\/overview\/attck/}
                        to={'/overview/attck'}
                        pathName={pathname}
                        key={'attck'}
                        level={1}
                        show
                        icon={<SvgIcon width={16} height={16} name={'ATTCK'} />}
                      />
                    </>
                  }
                />

                {(superSU?.phish === 1 ||
                  (superSU?.['email-gateway'] && superSU['email-gateway'] === 1) ||
                  (superSU?.['web-gateway'] && superSU['web-gateway'] === 1) ||
                  (superSU.waf && superSU.waf === 1) ||
                  (superSU?.['threat-protection'] && superSU['threat-protection'] === 1) ||
                  (superSU?.['endpoint-security'] && superSU['endpoint-security'] === 1) ||
                  (superSU?.['data-protection'] && superSU['data-protection'] === 1) ||
                  (superSU?.['container-security'] && superSU['container-security'] === 1)) && (
                  <MenuItem
                    pathName={pathname}
                    text={
                      <div className="navigation">
                        <span />
                        <span className="title">{t('攻击模拟')}</span>
                      </div>
                    }
                    test={/^\/validation/}
                    handelTopMenu={handelTopMenu}
                    menuName="validation"
                    subMenuItems={
                      <>
                        <SubMenuItem
                          text={t('人员安全意识')}
                          pathName={pathname}
                          show={superSU?.phish === 1}
                          key={'sense-security'}
                          level={1}
                          to="/validation/awareness"
                          icon={<SvgIcon width={16} height={16} name={'人员安全意识'} />}
                          subMenuItems={
                            <>
                              <SubMenuItem
                                text={t('钓鱼邮件')}
                                test={/^\/validation\/awareness\/phishing/}
                                to={'/validation/awareness/phishing'}
                                pathName={pathname}
                                show={superSU?.phish === 1}
                                key={'phishing'}
                                level={2}
                              />
                            </>
                          }
                        />

                        <SubMenuItem
                          text={t('网络安全')}
                          pathName={pathname}
                          show={
                            superSU?.['email-gateway'] === 1 ||
                            superSU?.['web-gateway'] === 1 ||
                            superSU?.waf === 1 ||
                            superSU?.['threat-protection'] === 1 ||
                            superSU?.['endpoint-security'] === 1
                          }
                          level={1}
                          key={'web-security'}
                          to="/validation/network"
                          icon={<SvgIcon width={16} height={16} name={'网络安全'} />}
                          subMenuItems={
                            <>
                              <SubMenuItem
                                text={t('Web安全')}
                                test={/^\/validation\/network\/waf/}
                                to={'/validation/network/waf'}
                                pathName={pathname}
                                show={superSU?.waf === 1}
                                key={'waf'}
                                level={2}
                              />

                              <SubMenuItem
                                text={t('邮件安全')}
                                test={/^\/validation\/network\/emailgateway/}
                                to={'/validation/network/emailgateway'}
                                pathName={pathname}
                                show={superSU?.['email-gateway'] === 1}
                                key={'email-gateway'}
                                level={2}
                              />

                              <SubMenuItem
                                text={t('威胁情报')}
                                test={/^\/validation\/network\/webgateway/}
                                to={'/validation/network/webgateway'}
                                pathName={pathname}
                                show={superSU?.['web-gateway'] === 1}
                                key={'web-gateway'}
                                level={2}
                              />

                              <SubMenuItem
                                text={t('流量安全')}
                                test={/^\/validation\/network\/threatprotection/}
                                to={'/validation/network/threatprotection'}
                                pathName={pathname}
                                show={superSU?.['threat-protection'] === 1}
                                key={'threat-protection'}
                                level={2}
                              />

                              <SubMenuItem
                                text={t('终端安全')}
                                test={/^\/validation\/network\/endpointsecurity/}
                                to={'/validation/network/endpointsecurity'}
                                pathName={pathname}
                                show={superSU?.['endpoint-security'] === 1}
                                key={'endpoint-security'}
                                level={2}
                              />
                            </>
                          }
                        />

                        <SubMenuItem
                          text={t('数据安全')}
                          pathName={pathname}
                          test={/^\/validation\/data/}
                          to={'/validation/data'}
                          show={superSU?.['data-protection'] === 1}
                          key={'data-security'}
                          level={1}
                          icon={<SvgIcon width={16} height={16} name={'数据安全'} />}
                          subMenuItems={
                            <>
                              <SubMenuItem
                                text={t('数据防泄漏')}
                                test={/^\/validation\/data\/dataprotection/}
                                to={'/validation/data/dataprotection'}
                                pathName={pathname}
                                show={superSU?.['data-protection'] === 1}
                                key={'data-protection'}
                                level={2}
                              />
                            </>
                          }
                        />

                        <SubMenuItem
                          text={t('云原生安全')}
                          pathName={pathname}
                          test={/^\/validation\/cloud/}
                          to={'/validation/cloud'}
                          show={superSU?.['container-security'] === 1}
                          key={'cloud-security'}
                          level={1}
                          icon={<SvgIcon width={16} height={16} name={'云原生安全'} />}
                          subMenuItems={
                            <>
                              <SubMenuItem
                                text={t('容器安全')}
                                test={/^\/validation\/cloud\/containersecurity/}
                                to={'/validation/cloud/containersecurity'}
                                pathName={pathname}
                                show={superSU?.['container-security'] === 1}
                                key={'container-security'}
                                level={2}
                              />
                            </>
                          }
                        />
                      </>
                    }
                  />
                )}
                {superSU?.orchestration && superSU?.orchestration === 1 && (
                  <MenuItem
                    pathName={pathname}
                    text={
                      <div className="navigation">
                        <span />
                        <span className="title">{t('攻击编排')}</span>
                      </div>
                    }
                    test={/^\/script/}
                    handelTopMenu={handelTopMenu}
                    menuName="script"
                    subMenuItems={
                      <>
                        <SubMenuItem
                          text={t('剧本编排')}
                          test={/^\/script\/arrange/}
                          to={'/script/arrange'}
                          pathName={pathname}
                          show
                          key={'script-arrange'}
                          level={1}
                          icon={<SvgIcon width={16} height={16} name={'剧本编排'} />}
                        />

                        <SubMenuItem
                          text={t('剧本运行')}
                          test={/^\/script\/execute/}
                          to={'/script/execute'}
                          pathName={pathname}
                          show
                          key={'script-execute'}
                          level={1}
                          icon={<SvgIcon width={16} height={16} name={'剧本运行'} />}
                        />
                      </>
                    }
                  />
                )}

                <MenuItem
                  pathName={pathname}
                  text={
                    <div className="navigation">
                      <span />
                      <span className="title">{t('用例知识库')}</span>
                    </div>
                  }
                  test={/^\/useCase/}
                  show
                  handelTopMenu={handelTopMenu}
                  menuName="useCase"
                  subMenuItems={
                    <>
                      <SubMenuItem
                        text={t('模板中心')}
                        test={/^\/useCase\/knowledge\/template-center/}
                        to="/useCase/knowledge/template-center"
                        pathName={pathname}
                        show
                        level={1}
                        key={'template-center'}
                        icon={<SvgIcon width={16} height={16} name={'模版中心'} />}
                      />

                      <SubMenuItem
                        text={t('用例中心')}
                        test={/^\/useCase\/knowledge\/useCase-center/}
                        to="/useCase/knowledge/useCase-center"
                        pathName={pathname}
                        show
                        level={1}
                        key={'use-case-center'}
                        icon={<SvgIcon width={16} height={16} name={'用例中心'} />}
                      />
                    </>
                  }
                />

                <MenuItem
                  pathName={pathname}
                  text={
                    <div className="navigation">
                      <span />
                      <span className="title">{t('报表管理')}</span>
                    </div>
                  }
                  test={/^\/report/}
                  handelTopMenu={handelTopMenu}
                  menuName="report"
                  subMenuItems={
                    <>
                      <SubMenuItem
                        text={t('报表任务')}
                        to={'/report/task'}
                        pathName={pathname}
                        show
                        level={1}
                        icon={<SvgIcon width={16} height={16} name={'报表管理'} />}
                        subMenuItems={
                          <>
                            <SubMenuItem
                              text={t('任务报表')}
                              test={/^\/report\/task\/task-report/}
                              to={'/report/task/task-report'}
                              pathName={pathname}
                              show
                              level={2}
                              key={'task-report'}
                            />

                            <SubMenuItem
                              text={t('综合报表')}
                              test={/^\/report\/task\/general-report/}
                              to={'/report/task/general-report'}
                              pathName={pathname}
                              show
                              level={2}
                              key={'general-report'}
                            />
                          </>
                        }
                      />
                    </>
                  }
                />

                <MenuItem
                  pathName={pathname}
                  text={
                    <div className="navigation">
                      <span />
                      <span className="title">{t('配置中心')}</span>
                    </div>
                  }
                  test={/^\/configure/}
                  handelTopMenu={handelTopMenu}
                  menuName="configure"
                  subMenuItems={
                    <>
                      <SubMenuItem
                        text={t('设备日志管理')}
                        to="/configure/log"
                        pathName={pathname}
                        show
                        level={1}
                        icon={<SvgIcon width={16} height={16} name={'设备日志管理'} />}
                        subMenuItems={
                          <>
                            <SubMenuItem
                              text={t('日志源管理')}
                              test={/^\/configure\/log\/source/}
                              to="/configure/log/source"
                              pathName={pathname}
                              show
                              level={2}
                              key={'log-source-management'}
                            />

                            <SubMenuItem
                              text={t('日志解析规则')}
                              test={/^\/configure\/log\/parse/}
                              to="/configure/log/parse"
                              pathName={pathname}
                              show
                              level={2}
                              key={'log-parse-rule'}
                            />

                            <SubMenuItem
                              text={t('过滤规则管理')}
                              test={/^\/configure\/log\/filter/}
                              to="/configure/log/filter"
                              pathName={pathname}
                              show
                              level={2}
                              key={'log-filter-rule'}
                            />

                            <SubMenuItem
                              text={t('日志设备管理')}
                              test={/^\/configure\/log\/log-management/}
                              to="/configure/log/log-management"
                              pathName={pathname}
                              show
                              level={2}
                              key={'log-device-management'}
                            />

                            <SubMenuItem
                              text={t('日志查询管理')}
                              test={/^\/configure\/log\/log-query/}
                              to="/configure/log/log-query"
                              pathName={pathname}
                              show
                              level={2}
                              key={'log-query-management'}
                            />
                          </>
                        }
                      />

                      <SubMenuItem
                        text={t('安全设备管理')}
                        pathName={pathname}
                        show
                        to={'/configure/device'}
                        level={1}
                        icon={<SvgIcon width={16} height={16} name={'安全设备管理'} />}
                        subMenuItems={
                          <>
                            <SubMenuItem
                              text={t('设备分析概览')}
                              test={/^\/configure\/device\/analytical-overview/}
                              to="/configure/device/analytical-overview"
                              pathName={pathname}
                              level={2}
                              key={'device-analytical-overview'}
                              show
                            />

                            <SubMenuItem
                              text={t('设备链路管理')}
                              test={/^\/configure\/device\/link-management/}
                              to="/configure/device/link-management"
                              pathName={pathname}
                              level={2}
                              key={'device-link-management'}
                              show
                            />

                            <SubMenuItem
                              text={t('设备接入管理')}
                              test={/^\/configure\/device\/access-management/}
                              to="/configure/device/access-management"
                              pathName={pathname}
                              level={2}
                              key={'device-access-management'}
                              show
                            />

                            <SubMenuItem
                              text={t('设备类型管理')}
                              test={/^\/configure\/device\/type-management/}
                              to="/configure/device/type-management"
                              pathName={pathname}
                              level={2}
                              key={'device-type-management'}
                              show
                            />

                            <SubMenuItem
                              text={t('设备厂商管理')}
                              test={/^\/configure\/device\/brand-management/}
                              to="/configure/device/brand-management"
                              pathName={pathname}
                              level={2}
                              key={'device-brand-management'}
                              show
                            />
                          </>
                        }
                      />

                      <SubMenuItem
                        text={t('资产管理')}
                        pathName={pathname}
                        show
                        to={'/configure/site'}
                        level={1}
                        icon={<SvgIcon width={16} height={16} name={'资产管理'} />}
                        subMenuItems={
                          <>
                            <SubMenuItem
                              text={t('Web应用')}
                              test={/^\/configure\/site\/resource/}
                              to={'/configure/site/resource'}
                              pathName={pathname}
                              show
                              key={'site-resource'}
                              level={2}
                            />
                            <SubMenuItem
                              text={t('验证主机')}
                              test={/^\/configure\/site\/host/}
                              to={'/configure/site/host'}
                              pathName={pathname}
                              show
                              key={'site-host'}
                              level={2}
                            />

                            <SubMenuItem
                              text={t('验证邮箱')}
                              test={/^\/configure\/site\/mailbox/}
                              to={'/configure/site/mailbox'}
                              pathName={pathname}
                              show
                              key={'site-mailbox'}
                              level={2}
                            />
                            {!menuList?.privatize && (
                              <SubMenuItem
                                text={'资产认证'}
                                test={/^\/configure\/site\/asset/}
                                to={'/configure/site/asset'}
                                pathName={pathname}
                                show
                                key={'site-asset'}
                                level={2}
                              />
                            )}
                          </>
                        }
                      />

                      <SubMenuItem
                        text={t('客户端管理')}
                        test={/^\/configure\/client\/list/}
                        to={'/configure/client/list'}
                        pathName={pathname}
                        show
                        key={'client-list'}
                        level={1}
                        icon={<SvgIcon width={16} height={16} name={'客户端管理'} />}
                      />

                      <SubMenuItem
                        text={t('代理池')}
                        test={/^\/configure\/proxy\/list/}
                        to={'/configure/proxy/list'}
                        pathName={pathname}
                        show
                        key={'proxy-list'}
                        level={1}
                        icon={<SvgIcon width={16} height={16} name={'代理池'} />}
                      />

                      <SubMenuItem
                        text={t('安全域')}
                        test={/^\/configure\/securitydomain\/list/}
                        to={'/configure/securitydomain/list'}
                        pathName={pathname}
                        show
                        key={'securitydomain-list'}
                        level={1}
                        icon={<SvgIcon width={16} height={16} name={'安全域'} />}
                      />
                    </>
                  }
                />

                <MenuItem
                  pathName={pathname}
                  text={
                    <div className="navigation">
                      <span />
                      <span className="title">{t('系统管理')}</span>
                    </div>
                  }
                  test={/^\/system/}
                  handelTopMenu={handelTopMenu}
                  menuName="system"
                  subMenuItems={
                    <>
                      {menuList?.privatize && (
                        <SubMenuItem
                          text={t('数据外发')}
                          test={/^\/system\/data-outsource/}
                          to={'/system/data-outsource'}
                          pathName={pathname}
                          show
                          level={1}
                          icon={<SvgIcon width={16} height={16} name={'数据外发'} />}
                        />
                      )}

                      <SubMenuItem
                        text={t('攻击管理')}
                        test={/^\/system\/attack-management/}
                        to={'/system/attack-management'}
                        pathName={pathname}
                        show
                        level={1}
                        icon={<SvgIcon width={16} height={16} name={'攻击管理'} />}
                      />

                      <SubMenuItem
                        text={t('联动管理')}
                        test={/^\/system\/linkage/}
                        to={'/system/linkage'}
                        pathName={pathname}
                        show
                        level={1}
                        icon={<SvgIcon width={16} height={16} name={'联动管理'} />}
                      />

                      <SubMenuItem
                        text={t('任务管理')}
                        test={/^\/system\/task/}
                        to={'/system/task'}
                        pathName={pathname}
                        show
                        level={1}
                        icon={<SvgIcon width={16} height={16} name={'任务管理'} />}
                      />

                      <SubMenuItem
                        text={t('授权管理')}
                        test={/^\/system\/authorize-manage/}
                        to={'/system/authorize-manage'}
                        pathName={pathname}
                        show
                        level={1}
                        icon={<SvgIcon width={16} height={16} name={'授权管理'} />}
                      />

                      <SubMenuItem
                        text={t('邮件服务器')}
                        test={/^\/system\/email-server/}
                        to={'/system/email-server'}
                        pathName={pathname}
                        show
                        level={1}
                        icon={<SvgIcon width={16} height={16} name={'邮件服务器'} />}
                      />

                      <SubMenuItem
                        text={t('通知管理')}
                        test={/^\/system\/email-manage/}
                        to={'/system/email-manage'}
                        pathName={pathname}
                        show
                        level={1}
                        icon={<SvgIcon width={16} height={16} name={'通知管理'} />}
                      />

                      {/* <SubMenuItem
                     text={'系统服务监控'}
                     test={/^\/system\/service-monitor/}
                     to={'/system/service-monitor'}
                     pathName={pathname}
                     show
                     level={1}
                     icon={<SvgIcon width={16} height={16} name={'系统服务监控'} />}
                    /> */}
                      <SubMenuItem
                        text={'Open API'}
                        test={/^\/system\/open-api/}
                        to={'/system/open-api'}
                        pathName={pathname}
                        show
                        level={1}
                        icon={<SvgIcon width={16} fill="#fff" height={16} name={'open API'} />}
                      />

                      <SubMenuItem
                        text={t('操作日志')}
                        test={/^\/system\/operate-log/}
                        to={'/system/operate-log'}
                        pathName={pathname}
                        show
                        level={1}
                        icon={<SvgIcon width={16} height={16} name={'操作日志'} />}
                      />

                      <SubMenuItem
                        text={t('关于')}
                        test={/^\/system\/about/}
                        to={'/system/about'}
                        pathName={pathname}
                        show
                        level={1}
                        icon={<SvgIcon width={16} height={16} name={'关于'} />}
                      />
                    </>
                  }
                />

                {menuList.privatize && menuList.items.find(item => item.id === '12').checked === 1 && (
                  <MenuItem
                    pathName={pathname}
                    text={
                      <div className="navigation">
                        <span />
                        <span className="title">{t('运维管理')}</span>
                      </div>
                    }
                    test={/^\/operation-management/}
                    handelTopMenu={handelTopMenu}
                    menuName="operation-management"
                    subMenuItems={
                      <>
                        <SubMenuItem
                          text={t('系统升级')}
                          test={/^\/operation-management\/system-upgrade/}
                          to={'/operation-management/system-upgrade'}
                          pathName={pathname}
                          show
                          level={1}
                        />

                        <SubMenuItem
                          text={t('规则升级')}
                          test={/^\/operation-management\/rule-upgrade/}
                          to={'/operation-management/rule-upgrade'}
                          pathName={pathname}
                          show
                          level={1}
                        />
                      </>
                    }
                  />
                )}
              </div>
              <div className="right-box">
                <div
                  className="client-download"
                  onClick={() => navigator('/configure/client/download')}
                >
                  <SvgIcon width={20} height={17} name="客户端下载" />
                </div>
                <HeaderRight userInfo={userInfo} />
              </div>
            </HeaderContent>
          </>
        </HeaderContainer>
      )}
    </>
  )
}
interface MenuItemContainerProps {
  isActive: boolean
  show: boolean
}

const SubMenuItemContainer = styled.div<MenuItemContainerProps>`
  font-size: 14px;
  width: 136px;
  height: 40px;
  line-height: 40px;
  margin: 4px;
  display: flex;
  align-items: center;
  font-weight: 500;
  padding: 0 16px;
  background: ${props => (props.isActive ? '#4c4f72' : '#1a253c')};
  visibility: ${props => (props.show ? 'visible' : 'hidden')};
  border-radius: 6px;
  transition: all 0.3s;
  position: relative;
  &:after {
    content: '';
    width: 20px;
    height: 40px;
    position: absolute;
    top: 0px;
    right: -10px;
    opacity: 0;
  }
  .menu-name-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  &:hover {
    background: #4c4f72;
  }
`

const MenuItemContainer = styled.div<MenuItemContainerProps>`
  position: relative;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  font-size: 14px;
  cursor: pointer;
  color: ${props => (props.isActive ? '#fff' : '#D0D0D0')};
  margin-right: 38px;
  .submenu-container {
    display: none;
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 999;
    width: 144px;
    border-radius: 8px;
    background: #1a253c;
    opacity: 0.95;
    flex-direction: column;
  }
  .submenu-container-3 {
    display: none;
    top: -4px;
    left: calc(103% + 1px);
    position: absolute;
    z-index: 999;
    width: 144px;
    border-radius: 8px;
    background: #1a253c;
    opacity: 0.95;
    flex-direction: column;
  }
  .navigation {
    max-width: 100px;
    min-width: 28px;
    height: 100%;
    display: flex;
    align-items: center;
    overflow: hidden;
    white-space: nowrap;
    .title {
      margin-left: 10px;
      display: inline-block;
      display: flex;
      justify-content: center;
      &::before {
        display: ${props => (props.isActive ? 'block' : 'none')};
        content: '';
        position: absolute;
        bottom: 11px;
        width: 32px;
        height: 2px;
        background: linear-gradient(90deg, #5e55e6 0%, #2090a8 100%);
        border-radius: 1px;
      }
    }
  }

  &:hover {
    color: #fff;
    .submenu-container {
      display: flex;
    }
  }
`

const HeaderContent = styled.div`
  flex-grow: 1;
  width: 0;
  display: flex;
  justify-content: space-between;
  .right-box {
    display: flex;
    align-items: center;
  }
  .menu-content {
    display: flex;
  }
  .client-download {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    margin-top: 10px;
    margin-right: 12px;
    &:hover {
      cursor: pointer;
      background: #22213c;
    }
  }
`

const HeaderContainer = styled.div`
  height: 56px;
  min-width: 1440px;
  max-width: 2560px;
  width: 100vw;
  background: linear-gradient(90deg, #070035 0%, #080039 100%);
  box-shadow: 0px 1px 12px 0px #362a9f;
  display: ${props => (props.fullScreen ? 'none' : 'flex')};
  margin: 0 auto;
  .switchicon {
    width: 100px;
    height: 40px;
    display: flex;
    margin-top: 7px;
    align-items: center;
    justify-content: center;
    background: #0b0a27;
    border: #0b0a27;
  }
  .nav {
    width: 124px;
    height: 28px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    padding-left: 16px;
    text-decoration: none;
  }
  .active {
    color: #4238c9;
    background: #ebeef7;
  }
  .ant-dropdown-menu-item-active {
    background: transparent;
  }
  .switch {
    &:hover {
      background: rgba(255, 255, 255, 0.1);
    }
  }
  .hasMenuEmptyBox {
    width: 50px;
    height: 56px;
  }
  .noMenuEmptyBox {
    width: 100px;
    height: 56px;
  }
`
const TitleContainer = styled.div`
  width: 157px;
  display: flex;
  align-items: center;
  padding-left: 32px;
  .title {
    margin-left: 8px;
    font-size: 16px;
    color: #fff;
    font-weight: 500;
    letter-spacing: 1px;
  }
  .logo {
    width: 125px;
    height: 32px;
    overflow: hidden;
  }
`
